import { Button, Space, Modal, Image, Alert } from 'antd';
import { useTranslation } from 'react-i18next';
import { TRANSLATION_NAMESPACES } from 'util/translation/constant';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useState } from 'react';
import PropType from 'prop-types';
import { EMExample } from 'assets/images';
import { PrimaryButton } from 'components/UI/PrimaryButton';
import { TextButton } from 'components/UI/TextButton';

const EM_URL = process.env.REACT_APP_EM_URL;
const IS_OPEN_MODAL_TO_EM_KEY = 'kira-storage-is-open-em';

const EMModal = ({ isModalOpen, setIsModalOpen }) => {
  const { t } = useTranslation(TRANSLATION_NAMESPACES.AUTHENTICATION);

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleStay = () => {
    setIsModalOpen(false);
    localStorage.setItem(IS_OPEN_MODAL_TO_EM_KEY, false);
  };

  return (
    <Modal
      title={t('emModalTitle')}
      open={isModalOpen}
      width={784}
      onCancel={handleCancel}
      footer={[
        <TextButton key="back" size="large" onClick={handleStay}>
          {t('emModalStay')}
        </TextButton>,
        <PrimaryButton key="submit" size="large" href={EM_URL}>
          {t('emModalToEm')}
        </PrimaryButton>
      ]}>
      <p>{t('emModalDescription')}</p>
      <Image preview={false} src={EMExample} />
    </Modal>
  );
};

EMModal.propTypes = {
  isModalOpen: PropType.bool.isRequired,
  setIsModalOpen: PropType.func.isRequired
};

export const EMBannerContent = () => {
  const isOpenModalToEm =
    localStorage.getItem(IS_OPEN_MODAL_TO_EM_KEY) === 'true' ||
    localStorage.getItem(IS_OPEN_MODAL_TO_EM_KEY) === null;

  const { t } = useTranslation(TRANSLATION_NAMESPACES.AUTHENTICATION);
  const [isModalOpen, setIsModalOpen] = useState(isOpenModalToEm);

  const handleInfo = () => {
    setIsModalOpen(true);
  };

  return (
    <Space direction="horizontal" align="center" size="large">
      <span>{t('emBannerDescription')}</span>
      <Button
        size="middle"
        type="default"
        href={EM_URL}
        className="btn btn-black">
        {t('emBannerToEm')}
      </Button>
      <Button type="text" icon={<InfoCircleOutlined />} onClick={handleInfo}>
        {t('emBannerInfo')}
      </Button>
      <EMModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
    </Space>
  );
};

export const EMBanner = () => (
  <Alert
    showIcon={false}
    type="warning"
    banner
    message={<EMBannerContent />}
    className="em-banner"
  />
);
